import { COLORS } from 'helpers/globals'
import { row, column } from 'helpers/styles/grid'

export default {
  CalculatorModel: {
    ...row,
    paddingBottom: '.4rem',
    lineHeight: '3.5rem'
  },
  inputs: row,
  label: {
    ...column,
    flex: '0 0 22%',
    maxWidth: '22% !important',
    paddingRight: '0 !important',
    marginRight: '0 !important',
    color: 'black'
  },
  noSelect: {
    color: 'black'
  },
  modelLinkContainer: {
    ...column,
    position: 'relative'
  },
  modelLink: { textDecoration: 'underline' },
  selectCameraLink: {
    background: COLORS.primary,
    color: 'white',
    fontSize: '1.2rem',
    height: 20,
    display: 'inline-block',
    verticalAlign: 'middle',
    textAlign: 'center',
    lineHeight: '20px',
    borderRadius: 4,
    marginLeft: '.5rem',
    fontWeight: 'bold',
    padding: '0 .5rem',
    cursor: 'pointer'
  }
}



// WEBPACK FOOTER //
// ./src/components/GeneralPanelContainer/CalculatorModel/style.js